import z from "zod";

export const contactPreviewPopoverDataSchema = z.object({
  contactId: z.coerce.number().int().positive(),
  side: z.enum(["top", "right", "bottom", "left"]).optional(),
  label: z.string().optional(),
  avatarUrl: z
    .string()
    .optional()
    .describe(
      "Opens the card from the person's picture instead of the info icon.",
    ),
  highlighted: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false")
    .describe(
      "Sets the avatar apart from its neighbours with an accent ring, the intervention planning uses it for the team lead.",
    ),
});

export type ContactPreviewPopoverDataProps = z.infer<
  typeof contactPreviewPopoverDataSchema
>;
